
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { StaticPerEntities } from "../dashbord.model.ts";

interface EntityComplaintNumberProps {
  plaintes?: StaticPerEntities[];
}

const EntityComplaintNumber: React.FC<EntityComplaintNumberProps>  = ({plaintes}) => {

  return (
    <div className="bg-white rounded-lg shadow-md w-full">
      <div className="p-4 text-md font-semibold text-gray-600 border-b border-gray-300 pb-2">
        Nombre de plaintes reçues par entité
      </div>
      <div className="p-4 m-4">
        <div className="" style={{ maxWidth: "100%" }}>
          <DataTable
            value={plaintes}
            removableSort
            stripedRows
            size="small"
            scrollable
            scrollHeight="400px"
          >
            <Column field="key" header="Entité" className="w-3/4" />
            <Column
              field="value"
              header="Nombre de plaintes"
              className="w-1/4"
              align={"right"}
            />
          </DataTable>
        </div>
      </div>
    </div>
  );
};

export default EntityComplaintNumber;
